import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldPasswordComponent } from './form-field-password.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    FormFieldPasswordComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  exports: [
    FormFieldPasswordComponent
  ]
})
export class FormFieldPasswordModule { }
